import { gql } from '@apollo/client';

const GET_ORG_UNITS_PERFORMANCE_REPORT = gql`
  query GetMddapOrgUnitPerformanceReport($id: Int!) {
    mddapOrgUnitPerformanceReport(id: $id) {
      Id
      MeasurementName
    }
  }
`;

export default GET_ORG_UNITS_PERFORMANCE_REPORT;
